import * as yup from 'yup'
import { REQUIRED_MESSAGE, INVALID_MESSAGE } from 'validations/messages'

export const yupValidacaoContato = yup.object().shape({
  email: yup.string().trim().required(REQUIRED_MESSAGE('E-mail')).email(INVALID_MESSAGE('e-mail')),
  celular: yup.string().required(REQUIRED_MESSAGE('Celular')).length(15, INVALID_MESSAGE('número')),
})
